import { DurationMetricChart } from '../../../renderers/duration-metric-chart/duration-metric-chart.component';
import { ChartRendererProps } from '../../../types/chart-renderer-props';
import { TRANSACTION_TIMER_PICK_UP_PENDING_DURATION_METRIC_CHART_DEFINITION } from './transaction-timer-pick-up-pending-duration-metric-chart.definition';
import { TRANSACTION_TIMER_PICK_UP_PENDING_DURATION_METRIC_CHART_MOCK_DATA } from './transaction-timer-pick-up-pending-duration-metric-chart.mock';

export const TransactionTimerPickUpPendingDurationMetricChart = (props: ChartRendererProps) => <DurationMetricChart {...props} />;

TransactionTimerPickUpPendingDurationMetricChart.definition = TRANSACTION_TIMER_PICK_UP_PENDING_DURATION_METRIC_CHART_DEFINITION;
TransactionTimerPickUpPendingDurationMetricChart.mockData = TRANSACTION_TIMER_PICK_UP_PENDING_DURATION_METRIC_CHART_MOCK_DATA;
